import { CButton, CSpinner } from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilExternalLink } from "@coreui/icons";
import { useOpenBillingPortal } from "../../api/hooks/useBilling";

/**
 * The way out of a payment that didn't go through. It opens Stripe straight on changing the account's card,
 * so one change fixes every bill at once. Manage still opens the whole page.
 */
export function UpdateCardButton() {
  const portal = useOpenBillingPortal({ updateCard: true });

  return (
    <div>
      <CButton color="primary" onClick={portal.open} disabled={portal.isPending}>
        {portal.isPending && <CSpinner size="sm" className="me-2" />}
        Update card
        <CIcon icon={cilExternalLink} size="sm" className="ms-2 opacity-75" />
      </CButton>
      {portal.failed && (
        <div className="text-danger small mt-2">We couldn't open Stripe. Please try again.</div>
      )}
    </div>
  );
}
